if (!customElements.get('ns-crystal-details')) {
  customElements.define(
    'ns-crystal-details',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.trigger = this.querySelector('.ns-crystal-card__full-details-trigger');
        this.panel = this.querySelector('.ns-crystal-details-panel');
        this.closeButton = this.querySelector('.ns-crystal-details-panel__close');
        this.collapseButton = this.querySelector('.ns-crystal-details-panel__collapse');
        this.backdrop = this.querySelector('.ns-crystal-details-backdrop');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        if (!this.trigger || !this.panel || !this.closeButton || !this.collapseButton || !this.backdrop) return;

        this.trigger.addEventListener('click', () => this.toggle());
        this.closeButton.addEventListener('click', () => this.close());
        this.collapseButton.addEventListener('click', () => this.close());
        this.backdrop.addEventListener('click', () => this.close());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.dataset.open === 'true') this.close();
        });
        this.mobileQuery.addEventListener('change', () => this.close(false));
      }

      toggle() {
        if (this.dataset.open === 'true') {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        document.querySelectorAll('ns-crystal-details[data-open="true"]').forEach((details) => {
          if (details !== this && typeof details.close === 'function') details.close(false);
        });

        this.dataset.open = 'true';
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;

        if (this.mobileQuery.matches) {
          this.panel.setAttribute('aria-modal', 'true');
          this.backdrop.hidden = false;
          document.documentElement.classList.add('ns-crystal-details-open');
          this.closeButton.focus();
        } else {
          this.panel.focus({ preventScroll: true });
        }
      }

      close(returnFocus = true) {
        this.dataset.open = 'false';
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
        this.panel.removeAttribute('aria-modal');
        this.backdrop.hidden = true;
        document.documentElement.classList.remove('ns-crystal-details-open');

        if (returnFocus) this.trigger.focus();
      }
    }
  );
}
